<template>
  <v-container>
    <h1>{{ $t(`entities.machine.multiple`) }}</h1>
    <v-row>
      <v-col cols="4">
        <v-data-table
          :headers="headers"
          :items="mainStore.machines">
          <template #item="{ item }">
            <tr @click="activeMachine = item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.id_number_machine }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        cols="8"
        v-if="activeMachine !== null">
        <MachineView
          :machine="mainStore.machineDb[activeMachine]"
          @edit="
            dialogOptions = { open: true, id: activeMachine }
          " @delete="
            deleteMachine(activeMachine)
          " />
      </v-col>
    </v-row>

    <v-btn v-if="authStore.isDatabaseAdmin" @click="dialogOptions = { open: true, id: null }">{{
      $t(`entities.machine.create`)
    }}</v-btn>

    <v-dialog v-model="dialogOptions.open">
      <MachineEdit
        :id="dialogOptions.id"
        @save="editComplete" />
    </v-dialog>
  </v-container>
</template>

<script setup lang="ts">
import { computed, Ref, ref } from "vue";
import { useRouter } from "vue-router";
import MachineEdit from "./MachineEdit.vue";
import MachineView from "./MachineView.vue";

import { useSpaceStore } from "@/stores/spaceStore";
import { useMainStore } from "@/stores/mainStore";

import { onMounted } from "vue";
import axios from "axios";
import { useTranslation } from "i18next-vue";
import { useAuthStore } from "@/stores/authStore";
const { t } = useTranslation();

const activeMachine: Ref<string | null> = ref(null);

const spaceStore = useSpaceStore();
const authStore = useAuthStore()
const mainStore = useMainStore();


const router = useRouter();

const dialogOptions: Ref<{ open: boolean; id: string | null }> = ref({ open: false, id: null });

const headers = [
  { title: t("entities.machine.name"), value: "name" },
  {
    title: t("entities.machine.fields.id_number_machine"),
    value: "id_number_machine"
  }
];

function deleteMachine(id: string) {
  mainStore.deleteMachine(id);
}

async function editComplete() {
  dialogOptions.value = { open: false, id: null };
  mainStore.loadMachineDB();
}
</script>
